import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import toast from '../helpers/toast';
import { type WrappedTRPCClient } from '../helpers/trpcClientTypes';

// The Watch / Watching toggle of a board card, for web and mobile
// (.specs/notifications.md → Card watch). `watching` is undefined until the
// server answers; `setWatching` is the one-tap toggle, also used by the
// Unwatch action of a card-watch notification (with `enabled: false`, so no
// status query runs for each bell row).

const cardWatchQueryKey = (postId: string) => ['postWatch', 'status', postId];
const useCardWatch = (client, postId, t0) => {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  const queryClient = useQueryClient();
  let t3;
  if ($[2] !== postId) {
    t3 = cardWatchQueryKey(postId);
    $[2] = postId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const queryKey = t3;
  let t4;
  if ($[4] !== client || $[5] !== postId) {
    t4 = async () => {
      const [error, result] = await client.postWatch.status.query({
        postId
      });
      if (error) {
        throw error;
      }
      return result;
    };
    $[4] = client;
    $[5] = postId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== enabled || $[8] !== queryKey || $[9] !== t4) {
    t5 = {
      queryKey,
      queryFn: t4,
      enabled,
      staleTime: Infinity
    };
    $[7] = enabled;
    $[8] = queryKey;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    data
  } = useQuery(t5);
  let t6;
  if ($[11] !== client || $[12] !== postId || $[13] !== queryClient || $[14] !== queryKey) {
    t6 = async watching => {
      const [error_0, result_0] = await client.postWatch.set.mutate({
        postId,
        watching
      });
      if (error_0) {
        toast("Watch not changed", error_0.message, "error");
        return false;
      }
      queryClient.setQueryData(queryKey, result_0);
      toast(result_0.watching ? "Watching" : "Unwatched", result_0.watching ? "You will be told when this card moves, gets a comment or is assigned." : "You will not be told about this card any more.");
      return true;
    };
    $[11] = client;
    $[12] = postId;
    $[13] = queryClient;
    $[14] = queryKey;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const setWatching = t6;
  const t7 = data?.watching;
  let t8;
  if ($[16] !== setWatching || $[17] !== t7) {
    t8 = {
      watching: t7,
      setWatching
    };
    $[16] = setWatching;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default useCardWatch;